export const PRIVATE_RESALE_VISIBILITY = 'PRIVATE'

export const isPrivateBatch = batch =>
  batch && batch.visibility === PRIVATE_RESALE_VISIBILITY

export const isPrivateBundleBatch = batch =>
  isPrivateBatch(batch) && !batch.single_sell && batch.batch_size > 1

export const isPrivateBundleTicket = ticket =>
  isPrivateBundleBatch(ticket && ticket.batch)

export const getResalePath = batch => {
  if (!batch) {
    return '/'
  }

  return isPrivateBatch(batch)
    ? `/private-resale/${batch.private_token}`
    : `/tickets/${batch.id}`
}

export const getResaleUrl = batch => {
  const baseUrl = process.env.REACT_APP_URL || ''
  return `${baseUrl}${getResalePath(batch)}`
}
